export enum VariableType {
    Discrete = 0,
    Continuous = 1,
    Computed = 2,
    System = 3,
}
